import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { Location } from '@/models/location';
import { locationsService } from '@/services/locations.service';
import { ValidationRules } from '@/utils/validation';
import useVuelidate from '@vuelidate/core';
import { computed, onBeforeMount, reactive, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationsSelect',
  props: {
    value: null,
    validationRules: { default: () => ({}) },
    disabled: { type: Boolean, default: false },
    customerId: null
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ((e: 'input' | 'change', locationId: number | undefined) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: number, validationRules: ValidationRules, disabled: boolean, customerId: number };




const locations = ref<Location[]>([]);
const isLoading = ref(false);

const state = reactive({
  locationId: props.value,
});
const validations = {
  locationId: props.validationRules,
};
const v$ = useVuelidate(validations, state);
const { t } = useI18n();

onBeforeMount(() => {
  fetchLocations();
});

async function fetchLocations() {
  isLoading.value = true;
  locations.value = await locationsService
    .get(props.customerId)
    .finally(() => (isLoading.value = false));
}

function getErrorMessage() {
  return v$.value.locationId.$errors?.[0]?.$message;
}

watch(
  () => state.locationId,
  (locationId: number | undefined) => {
    emit('input', locationId);
    emit('change', locationId);
  },
);

const required = computed(() => 'required' in props.validationRules);

return { __sfc: true,props, emit, locations, isLoading, state, validations, v$, t, fetchLocations, getErrorMessage, required }
}

})